import multimethod from '../../../lib/multimethod';

const reportActions = multimethod('type', (action, state) => state);

const initialState = {};

export default (state = initialState, action) => reportActions(action, state);
